import styled from "@emotion/styled";
import Link from "next/link";
import { useRouter } from "next/router";

export default function HeadTitle({ children, as, ...props }) {
  const { locale } = useRouter();

  const Component = as || "h2";

  const Fancy = styled(Component)`
    font-weight: 500;
    font-size: 18px;
    line-height: 31px;
    color: ${({ theme }) => theme.palette.primary.main};
  `;

  return (
    <Link href={props.url} locale={locale}>
      <a>
        <Fancy className={props.className || "title"}>{children}</Fancy>
      </a>
    </Link>
  );
}
